import {ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LayoutService} from 'app/core/services/layout.service';
import {delay} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
    selector: 'sd-internal-dashboard-page',
    templateUrl: './sd-internal-dashboard-page.component.html',
    styleUrls: ['./sd-internal-dashboard-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdInternalDashboardPageComponent implements OnInit, OnDestroy {
    @ViewChild('iframe', {static: true}) iframe: ElementRef;
    frameLink: string;

    sub: Subscription = Subscription.EMPTY;

    constructor(public layout: LayoutService) {}

    makeSlimLayout() {
        this.layout.frameWithoutPaddings$.next(true);
        this.layout.footerVisible$.next(false);
    }

    ngOnInit() {
        setTimeout(() => this.makeSlimLayout(), 0);
        let queryString = window.location.search;

        if (queryString) {
            let urlParams = new URLSearchParams(queryString);
            let widget = urlParams.get('widget');

            if (widget) {
                this.frameLink = `${window.location.origin}/stack_dashboard/widgets/${widget}${queryString}&t=${new Date().getTime()}`;
            } else {
                this.frameLink = `${window.location.origin}/stack_dashboard/dashboard?t=${new Date().getTime()}`;
            }
        } else {
            this.frameLink = `${window.location.origin}/stack_dashboard/dashboard?t=${new Date().getTime()}`;
        }

        this.sub = this.layout.reloadFrame$.pipe(delay(300)).subscribe(reload => {
            if (reload) {
                this.reloadFrame();
            }
        });
    }

    reloadFrame() {
        const iframeEl = this.iframe.nativeElement;
        if (!iframeEl) {
            return;
        }

        iframeEl.src += '';
    }

    ngOnDestroy() {
        this.layout.frameWithoutPaddings$.next(false);
        this.layout.footerVisible$.next(true);
        this.sub.unsubscribe();
    }
}
